import React, { useEffect, useRef } from "react";
import {
    Chart,
    ScatterController,
    LinearScale, PointElement, LineElement, Title,
    CategoryScale,
    Tooltip
} from 'chart.js';
import { Selector } from "../../plugin/selector";
import chartTrendline from "chartjs-plugin-trendline";
import Zoom from "chartjs-plugin-zoom";

// No Legend plugin - both charts use the shared, hand-styled legend row in DataVisualizer.js
// instead (matches the mockup), never chart.js's own.
Chart.register(ScatterController, LinearScale, CategoryScale, PointElement, LineElement, Selector, Zoom, Title, chartTrendline, Tooltip);

export default function ScatterGraph(props) {
    const scatterChart = useRef(null);
    const contentId = useRef(null);
    const {data, reset, content, options} = props;
    contentId.current = content.id;

    useEffect(() => {
        console.log("scatterGraph useEffect");
        if(!contentId.current && !scatterChart.current) {
            scatterChart.current = new Chart(content.ref.current, options);
            contentId.current = content.id;
        }
        
        if(scatterChart && scatterChart.current && data) { 
            if(reset) {
                scatterChart.current.data.labels.pop();
                for(let i=0;i< scatterChart.current.data.datasets.length;i++){
                    scatterChart.current.data.datasets[i].data = [];
                }
                scatterChart.current.update();
            } else {
                for(let i=0;i<data.length;i++){
                    if(data[i].length > 0){
                        scatterChart.current.data.datasets[i].data = data[i];
                    }
                }

                scatterChart.current.update();
           }
        }
    }, [data, reset, content, options, scatterChart]);

    return (
        <>
            {content}
        </>  
    );
}

